import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbe54382"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authentication-login-group" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"side\" data-v-cbe54382><div class=\"side-text-wrap\" data-v-cbe54382><div class=\"welcome-text text-uppercase\" data-v-cbe54382> WELCOME TO </div><a href=\"/\" data-v-cbe54382><img class=\"logo\" src=\"/images/auth/login-logo.png\" alt=\"\" data-v-cbe54382></a></div></div>", 1)
const _hoisted_3 = {
  class: "form-container",
  style: {"color":"black !important"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mobile-logo",
    src: "/images/auth/login-logo.png",
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "auth-language-dropdown" }
const _hoisted_6 = {
  key: 0,
  id: "create-demo-account",
  class: "card w-800px mx-auto"
}
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "row"
}
const _hoisted_12 = { class: "col-lg-12 mb-5" }
const _hoisted_13 = { class: "required fs-6 fw-semibold mb-2" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "d-block fw-semibold text-start" }
const _hoisted_17 = { class: "text-dark fw-bold d-block" }
const _hoisted_18 = { class: "col-lg-12 mb-5" }
const _hoisted_19 = { class: "required fs-6 fw-semibold mb-2" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = ["for"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon me-5 svg-icon-1" }, null, -1))
const _hoisted_23 = { class: "d-block fw-semibold text-start" }
const _hoisted_24 = { class: "text-dark fw-bold d-block fs-4" }
const _hoisted_25 = { class: "col-lg-6 mb-5" }
const _hoisted_26 = { class: "required fs-6 fw-semibold mb-2" }
const _hoisted_27 = { class: "col-lg-6 mb-5" }
const _hoisted_28 = { class: "required fs-6 fw-semibold mb-2" }
const _hoisted_29 = { class: "col-lg-6 mb-5" }
const _hoisted_30 = {
  class: "required fs-6 fw-semibold mb-2",
  style: {"min-width":"160px"}
}
const _hoisted_31 = { class: "col-lg-6 mb-5" }
const _hoisted_32 = { class: "required fs-6 fw-semibold mb-2" }
const _hoisted_33 = { class: "col-lg-6 mb-5" }
const _hoisted_34 = { class: "required fs-6 fw-semibold mb-2" }
const _hoisted_35 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_36 = { class: "col-lg-6 mb-5" }
const _hoisted_37 = { class: "required fs-6 fw-semibold mb-2" }
const _hoisted_38 = { class: "card-footer" }
const _hoisted_39 = {
  key: 1,
  id: "create-demo-account",
  class: "card w-800px mx-auto",
  style: {"box-shadow":"rgba(99, 99, 99, 0.2) 0px 2px 8px 0px","padding":"20px"}
}
const _hoisted_40 = { class: "card-body text-center" }
const _hoisted_41 = {
  class: "mb-5",
  style: {"font-size":"28px"}
}
const _hoisted_42 = {
  class: "mb-3",
  style: {"font-size":"20px"}
}
const _hoisted_43 = {
  class: "mb-3",
  style: {"font-size":"20px"}
}
const _hoisted_44 = {
  class: "mb-11",
  style: {"font-size":"20px","color":"orange"}
}

import { onMounted, ref } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "@/store";
import LanguageDropdown from "@/projects/client/components/LanguageDropdown.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { AccountTypes } from "@/core/types/AccountInfos";
import { ServiceTypes } from "@/core/types/ServiceTypes";
import { ErrorMessage, Field, useForm } from "vee-validate";
import LoadingCentralBox from "@/components/LoadingCentralBox.vue";
import { useI18n } from "vue-i18n";
import { getRegionCodes } from "@/core/data/phonesData";
import { isMobile } from "@/core/config/WindowConfig";
import ClientGlobalService from "@/projects/client/services/ClientGlobalService";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import { useRoute, useRouter } from "vue-router";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import * as yup from "yup";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDemoAccount',
  setup(__props) {

const store = useStore();
const isLoading = ref(true);
const isSubmitting = ref(false);
const formData = ref<any>({});
const { t } = useI18n();
const i18nLang = useI18n();
const language = ref<any>();
const route = useRoute();
const nameError = ref(false);
const regionCodes = ref(getRegionCodes());
const phoneRegionCode = ref("");
const phoneInputSample = ref(t("tip.pleaseInput"));
const showSuccess = ref(false);
const amount = ref(null);

const amountSelections = ref([
  { label: "$10,000", value: 10000 },
  { label: "$50,000", value: 50000 },
  { label: "$100,000", value: 100000 },
]);

const tenantId = ref<string | null>(null);
// const validationSchema = {
//   accountType: "required",
//   platform: "required",
//   name: "required",
//   currency: "required",
//   countryCode: "required",
//   phoneNumber: "required",
//   email: "required|email",
// };
const router = useRouter();

const validationSchema = yup.object({
  accountType: yup.string().required(t("tip.requiredField")),
  platform: yup.string().required(t("tip.requiredField")),
  name: yup
    .string()
    .matches(/^[A-Za-z\s]*$/, t("tip.onlyEnglishCharacter"))
    .required(t("tip.requiredField")),

  amount: yup.number().required(t("tip.requiredField")),
  currency: yup.string().required(t("tip.requiredField")),
  countryCode: yup.string().required(t("tip.requiredField")),
  phoneNumber: yup.string().required(t("tip.requiredField")),
  email: yup
    .string()
    .email(t("tip.invalidEmail"))
    .required(t("tip.requiredField")),
});

const { handleSubmit, resetForm } = useForm({
  validationSchema,
});

const validateName = () => {
  const englishCharactersRegex = /^[A-Za-z\s]*$/;
  console.log(englishCharactersRegex.test(formData.value.name));
  if (!englishCharactersRegex.test(formData.value.name)) {
    nameError.value = true;
  } else {
    nameError.value = false;
  }
};

const initData = () => {
  language.value =
    (route.query.lang as string) ?? i18nLang.locale.value ?? LanguageTypes.enUS;
  tenantId.value = (route.query.tenantId as string) ?? null;
  i18nLang.locale.value = language.value;
  formData.value = {};
  resetForm({ values: {} });
};

const submit = handleSubmit(async () => {
  isSubmitting.value = true;
  const body = {
    ...formData.value,
    phoneNumber:
      regionCodes.value[phoneRegionCode.value]?.dialCode +
      formData.value.phoneNumber,
    referralCode: route.query["referralCode"],
    tenantId: tenantId.value,
    amount: amount.value,
  };
  // console.log(body);
  try {
    await ClientGlobalService.createDemoAccountFromNonAuth(body);
    MsgPrompt.success(t("tip.createDemoAccountSuccess")).then(() => {
      showSuccess.value = true;
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
});

const demoPlatformSelections = ref(Array<any>());
const accountTypeSelections = ref(Array<any>());
const currencySelections = ref(Array<any>());
onMounted(async () => {
  isLoading.value = true;

  await store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  accountTypeSelections.value = [
    {
      label: t(`type.account.${AccountTypes.Standard}`),
      value: AccountTypes.Standard,
      iconPath: "/images/icons/communication/com005.svg",
    },
    {
      label: t(`type.account.${AccountTypes.Alpha}`),
      value: AccountTypes.Alpha,
      iconPath: "/images/icons/finance/fin006.svg",
    },
  ];
  currencySelections.value = [
    {
      label: "USD",
      value: 840,
    },
    {
      label: "AUD",
      value: 36,
    },
  ];

  demoPlatformSelections.value = [
    {
      label: "MetaTrader 4",
      value: ServiceTypes.MetaTrader4Demo,
      iconPath: "/images/icons/brand/mt4.svg",
    },
    {
      label: "MetaTrader 5",
      value: ServiceTypes.MetaTrader5Demo,
      iconPath: "/images/icons/brand/mt5.svg",
    },
  ];
  // const publicConfig = await GlobalService.getConfiguration();
  // accountTypeSelections.value = publicConfig?.accountTypeAvailable.map(
  //   (typeEnum: AccountTypes) => {
  //     return {
  //       label: t(`type.account.${typeEnum}`),
  //       value: typeEnum,
  //       iconPath:
  //         {
  //           1: "/images/icons/communication/com005.svg",
  //           2: "/images/icons/finance/fin006.svg",
  //         }[typeEnum] ?? "/images/icons/communication/com005.svg",
  //     };
  //   }
  // );

  // currencySelections.value = publicConfig?.currencyAvailable.map(
  //   (currencyId: number) => {
  //     return {
  //       label: t(`type.currency.${currencyId}`),
  //       value: currencyId,
  //     };
  //   }
  // );

  // demoPlatformSelections.value =
  //   publicConfig?.demoTradingPlatformAvailable?.map(
  //     (availablePlatformId: number) => {
  //       return {
  //         label: t(`type.platform.${availablePlatformId}`),
  //         value: availablePlatformId,
  //         iconPath: `/images/icons/brand/${
  //           {
  //             [ServiceTypes.MetaTrader4Demo]: "mt4",
  //             [ServiceTypes.MetaTrader5Demo]: "mt5",
  //           }[availablePlatformId]
  //         }.svg`,
  //       };
  //     }
  //   );

  isLoading.value = false;
  initData();
});

const goRegister = () => {
  router.push({ name: "sign-up" });
};

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(LanguageDropdown)
      ]),
      (!showSuccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("action.createDemoAccount")), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(LoadingCentralBox)
                    ]))
                  : _createCommentVNode("", true),
                (!isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("fields.platform")), 1),
                        _createElementVNode("div", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(demoPlatformSelections.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-6",
                              key: index
                            }, [
                              _createVNode(_unref(Field), {
                                modelValue: formData.value.platform,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.platform) = $event)),
                                tabindex: "2",
                                type: "radio",
                                class: "btn-check",
                                name: "platform",
                                value: item.value,
                                id: 'CreativeDemoAccount' + item.label + item.value
                              }, null, 8, ["modelValue", "value", "id"]),
                              _createElementVNode("label", {
                                class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default d-flex align-items-center", {
                        ' w-125px h-125px flex-column  justify-content-center':
                          _unref(isMobile),
                      }]),
                                for: 'CreativeDemoAccount' + item.label + item.value
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["svg-icon svg-icon-3x", {
                          'mx-0 mb-3 svg-icon-4x': _unref(isMobile),
                        }])
                                }, [
                                  _createVNode(_component_inline_svg, {
                                    src: item.iconPath
                                  }, null, 8, ["src"])
                                ], 2),
                                _createElementVNode("span", _hoisted_16, [
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.label), 1)
                                ])
                              ], 10, _hoisted_15)
                            ]))
                          }), 128))
                        ]),
                        _createVNode(_unref(ErrorMessage), {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "platform",
                          as: "div"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("tip.requiredField")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("fields.type")), 1),
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountTypeSelections.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "col-lg-3 mb-3"
                            }, [
                              _createVNode(_unref(Field), {
                                modelValue: formData.value.accountType,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.accountType) = $event)),
                                type: "radio",
                                class: "btn-check",
                                name: "accountType",
                                value: item.value,
                                id: 'CreativeDemoAccount' + item.label + item.value
                              }, null, 8, ["modelValue", "value", "id"]),
                              _createElementVNode("label", {
                                class: "btn btn-outline btn-outline-dashed btn-outline-default p-5 d-flex align-items-center",
                                for: 'CreativeDemoAccount' + item.label + item.value
                              }, [
                                _hoisted_22,
                                _createElementVNode("span", _hoisted_23, [
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(item.label), 1)
                                ])
                              ], 8, _hoisted_21)
                            ]))
                          }), 128)),
                          _createVNode(_unref(ErrorMessage), {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "accountType",
                            as: "div"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("tip.requiredField")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("fields.amount")), 1),
                        _createElementVNode("div", null, [
                          _createVNode(_unref(Field), {
                            modelValue: amount.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((amount).value = $event)),
                            name: "amount"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: amount.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((amount).value = $event)),
                                name: "amount",
                                type: "text",
                                size: "large",
                                placeholder: _ctx.$t('fields.select')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "",
                                    disabled: "",
                                    label: _ctx.$t('fields.select')
                                  }, null, 8, ["label"]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(amountSelections.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      key: index,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_unref(ErrorMessage), {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "amount",
                            as: "div"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("tip.requiredField")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("fields.currency")), 1),
                        _createElementVNode("div", null, [
                          _createVNode(_unref(Field), {
                            modelValue: formData.value.currencyId,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.currencyId) = $event)),
                            name: "currency"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: formData.value.currencyId,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.currencyId) = $event)),
                                name: "currency",
                                type: "text",
                                size: "large",
                                placeholder: _ctx.$t('tip.selectCurrency')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "",
                                    disabled: "",
                                    label: _ctx.$t('tip.selectCurrency')
                                  }, null, 8, ["label"]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencySelections.value, ({ label, value }, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: label,
                                      key: index,
                                      value: value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_unref(ErrorMessage), {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "currency",
                            as: "div"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("tip.requiredField")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("fields.countryAndRegion")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: formData.value.countryCode,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.countryCode) = $event)),
                          className: "mt-1 form-control form-control-lg form-control-solid",
                          name: "countryCode",
                          autoComplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: formData.value.countryCode,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.countryCode) = $event)),
                              placeholder: _ctx.$t('tip.selectCountry'),
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (phoneRegionCode.value = formData.value.countryCode)),
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item.code
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_unref(ErrorMessage), {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "countryCode",
                          as: "div"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("tip.requiredField")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("fields.phoneNum")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: formData.value.phoneNumber,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.phoneNumber) = $event)),
                          class: "mt-1 form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "phoneNumber",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.value.phoneNumber,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.phoneNumber) = $event)),
                              placeholder: phoneInputSample.value,
                              size: "large",
                              name: "phoneNumber"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  size: "large",
                                  placeholder: _ctx.$t('action.select'),
                                  modelValue: phoneRegionCode.value,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((phoneRegionCode).value = $event)),
                                  style: {"width":"175px"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.code,
                                        label: `${item.name} +${item.dialCode}`,
                                        value: item.code
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["placeholder", "modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_unref(ErrorMessage), {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "phoneNumber",
                          as: "div"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("tip.requiredField")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("fields.name")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: formData.value.name,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.name) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "name",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.value.name,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.name) = $event)),
                              autocomplete: "off",
                              name: "name",
                              onInput: validateName,
                              clearable: "",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (nameError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.$t("tip.onlyEnglishCharacter")), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(ErrorMessage), {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "name",
                          as: "div"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("tip.requiredField")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("fields.email")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: formData.value.email,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.email) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "email",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.value.email,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.email) = $event)),
                              autocomplete: "off",
                              clearable: "",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_unref(ErrorMessage), {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "email",
                          as: "div"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("tip.invalidEmail")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createVNode(LoadingButton, {
                class: "btn btn-primary",
                onClick: _unref(submit),
                "is-loading": isSubmitting.value,
                "save-title": _ctx.$t('action.register')
              }, null, 8, ["onClick", "is-loading", "save-title"])
            ])
          ]))
        : _createCommentVNode("", true),
      (showSuccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("tip.congratulations")) + " ! ", 1),
              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("tip.createDemoAccountSuccessMsg")), 1),
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("tip.createDemoAccountSuccessMsg2")), 1),
              _createElementVNode("div", _hoisted_44, _toDisplayString(formData.value.email), 1),
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                onClick: goRegister
              }, _toDisplayString(_ctx.$t("action.register")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})